/*
=========================================================
ALITO Gallery v3
=========================================================
*/

document.addEventListener("DOMContentLoaded", () => {

    const gallery = document.querySelector('[id^="Slider-Gallery-"]');

    if (!gallery) return;

    const container = document.querySelector(".alito-gallery-dots");

    if (!container) return;

    const slides = [...gallery.querySelectorAll("li")];

const primerSlide = slides[0].cloneNode(true);
primerSlide.id = "alito-clon";
primerSlide.dataset.clon = "true";
gallery.appendChild(primerSlide);

    const total = slides.length;

    let ultimaPosicion = 0;

function obtenerIndiceActual() {

    const scrollActual = gallery.scrollLeft;

    let indice = 0;
    let distanciaMinima = Infinity;

    slides.forEach((slide, i) => {

        const distancia = Math.abs(slide.offsetLeft - scrollActual);

        if (distancia < distanciaMinima) {
            distanciaMinima = distancia;
            indice = i;
        }

    });

    return indice;

}

    container.innerHTML = "";

    for (let i = 0; i < total; i++) {

        const dot = document.createElement("span");

        dot.className = "alito-gallery-dot";

        if (i === 0) {
            dot.classList.add("active");
        }

        container.appendChild(dot);

    }

    const dots = container.querySelectorAll(".alito-gallery-dot");

function actualizarIndicador() {

    let indice = obtenerIndiceActual();

    if (indice >= total) {
        indice = 0;
    }

    dots.forEach(dot => dot.classList.remove("active"));

    if (dots[indice]) {
        dots[indice].classList.add("active");
    }

}

gallery.addEventListener("scroll", () => {

    const indice = obtenerIndiceActual();

    actualizarIndicador();

    ultimaPosicion = indice;

    if (gallery.scrollLeft >= primerSlide.offsetLeft - 5) {

        gallery.style.scrollBehavior = "auto";

        gallery.scrollLeft = 0;

        requestAnimationFrame(() => {

            gallery.style.scrollBehavior = "smooth";

            actualizarIndicador();

        });

    }

});

actualizarIndicador();

gallery.addEventListener("touchend", () => {

    const ancho = gallery.clientWidth;
    const indice = obtenerIndiceActual();

    if (indice >= total) {

        gallery.style.scrollBehavior = "auto";
        gallery.scrollLeft = ancho;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {

                gallery.style.scrollBehavior = "smooth";

                actualizarIndicador();

            });
        });

    }

});

});